import { render, staticRenderFns } from "./CurrentCheckins.vue?vue&type=template&id=52c1b648&scoped=true"
import script from "./CurrentCheckins.vue?vue&type=script&lang=js"
export * from "./CurrentCheckins.vue?vue&type=script&lang=js"
import style0 from "./CurrentCheckins.vue?vue&type=style&index=0&id=52c1b648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c1b648",
  null
  
)

export default component.exports